import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown } from 'components';
import { Building } from 'lane-shared/helpers/integrations/BuildingEnginesPrism/client/buildings';
import styles from './BuildingSelectionDropdown.scss';

interface BuildingSelectionDropdownProps {
  buildings: Building[];
  buildingId: string;
  setBuildingId: (id: string) => void;
  disabled?: boolean;
  showLabel?: boolean;
  label?: string;
  labelClassName?: string;
}

const BuildingSelectionDropdown = ({
  buildings,
  buildingId,
  setBuildingId,
  disabled = false,
  showLabel = false,
  label = 'shared.integrations.bePrism.selectBuilding',
  labelClassName = '',
}: BuildingSelectionDropdownProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.dropdownContainer}>
      {showLabel && (
        <div className={`${styles.label} ${labelClassName}`}>
          {t(label)}
        </div>
      )}
      <div className={styles.dropdown}>
        <Dropdown
          placeholder={t('shared.integrations.bePrism.selectBuilding')}
          value={buildingId}
          items={buildings.map(building => ({
            label: building.name,
            value: building.id,
          }))}
          onValueChange={value => {
            setBuildingId(value);
          }}
          name="building"
          isFullWidth
          disabled={disabled}
        />
      </div>
    </div>
  );
};

export default BuildingSelectionDropdown;
